// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onboarding-content[data-v-785335ec]{max-width:375px;margin:0 16px}@media screen and (min-width:400px){.onboarding-content[data-v-785335ec]{margin:0 auto}}[data-v-785335ec] .v-menu__content{margin-top:67px;border-radius:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
